import ExceptionState from '@space-lib/components/exceptionState'

import { useTranslation } from 'react-i18next'

import type { ExceptionProps } from './hooks/useExceptions'
import { useExceptions } from './hooks/useExceptions'

function ExceptionStateComponent({ buttonAction, exception }: ExceptionProps) {
  const { t } = useTranslation()
  const exceptions = useExceptions(t)

  return <ExceptionState exception={exceptions[exception]} buttonAction={buttonAction} />
}

export default ExceptionStateComponent
